import axios from "axios";

export default {
  namespaced: true,
  state: {
    regions: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    regionsMessage: ''
  },
  mutations: {
    CLEAR_REGIONS(state) {
      state.regions = [];
    },
    RECEIVED_REGIONS(state, payload) {
      state.regions = payload;
      state.isReceiving = false;
    },
    RECEIVING_REGIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_REGION(state, payload) {
      state = Object.assign(state, {
        regions: [...state.regions, payload],
        isReceiving: false,
      })
    },
    RECEIVING_REGION(state) {
      state.isReceiving = true;
    },
    UPDATED_REGION(state, payload) {
      let index = state.regions.findIndex(region => region._id === payload._id);
      state = Object.assign(state, {
        regions: state.regions.map((region, i) => {
          if (i === index) {
            return Object.assign({}, region, payload);
          }
          return region;
        }),
        isUpdating: false,
        regionsMessage: 'Regions has been updating!',
      })
    },
    UPDATING_REGION(state) {
      state.isUpdating = true;
    },
    DELETED_REGION(state, payload) {
      let indexToDelete = state.regions.findIndex(region => region._id === payload._id);
      let regions = [...state.regions];
      regions.splice(indexToDelete, 1);
      state = Object.assign(state, {
        regions: [...regions],
        isDeleting: false,
        idToDelete: null,
        regionsMessage: 'Region has been Deleted!',
      });
    },
    DELETING_REGION(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteRegionRequest({dispatch}, payload) {
      dispatch("deletingRegion", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/region/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteRegion", {_id: payload._id});
      })
    },
    getRegionsRequest({dispatch}) {
      dispatch("receivingRegions");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/regions';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveRegions", res.data);
      })
    },
    async insertRegionRequest({dispatch}, payload) {
      dispatch("receivingRegions");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/region/';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      console.log(payload)
      return axios({method: "post", url: url, headers: headers , data: data})
      .then(response=>{
        console.log(response.data)
        dispatch("receiveRegion", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.reponse.data.error;
      });	
    },
    async insertRegionWithImageRequest({dispatch}, payload) {
      dispatch("receivingRegions");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/region/';
      let data = new FormData();
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      data.append('image', payload.regionimage, payload.imagename); 
      delete payload['regionimage'];
      for (let x in payload) data.append(x, payload[x]);
      
      return axios({method: "post", url: url, headers: headers , data: data})
      .then(response =>{
        dispatch("receiveRegion", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.reponse.data.error;
      });	
    },
    updateRegionRequest({dispatch}, payload) {
      dispatch("updatingRegion");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/region/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      axios({method: "put", url: url, headers: headers, data: payload})
      .then(response => {
        dispatch("updateRegion", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    updateRegionImageRequest({dispatch}, payload) {
      dispatch("updatingRegion");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.accountxc.com:3100/update/region/image/' + id;
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      let data = new FormData();

      data.append('image', payload.regionimage, payload.imagename); 
      delete payload['regionimage'];
      for (let x in payload) data.append(x, payload[x]);

      axios({method: "put", url: url, headers: headers, data: data})
      .then(response => {
        dispatch("updateRegion", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    clearRegions({commit}) {
      commit("CLEAR_REGIONS")
    },
    receiveRegions({commit}, payload) {
      commit("RECEIVED_REGIONS", payload)
    },
    receivingRegions({commit}) {
      commit("RECEIVING_REGIONS")
    },
    receiveRegion({commit}, payload) {
      commit("RECEIVED_REGION", payload)
    },
    receivingRegion({commit}) {
      commit("RECEIVING_REGION")
    },
    updateRegion({commit}, payload) {
      commit("UPDATED_REGION", payload)
    },
    updatingRegion({commit}) {
      commit("UPDATING_REGION")
    },
    deleteRegion({commit}, payload) {
      commit("DELETED_REGION", payload)
    },
    deletingRegion({commit}, payload) {
      commit("DELETING_REGION", payload)
    }
  },
};
